import { Builder } from '@builder.io/react';

import SolutionsUseCases from './index';

Builder.registerComponent(SolutionsUseCases, {
  name: 'SolutionsUseCases',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: ['bg-transparent', 'bg-gray-950', 'bg-gray-900', 'bg-gray-100', 'bg-gray-800']
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'string'
    },
    {
      name: 'list',
      type: 'list',
      defaultValue: [
        {
          label: 'label'
        }
      ],
      subFields: [
        {
          name: 'label',
          type: 'string'
        },
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'jpg', 'png']
        },
        {
          name: 'srcHover',
          type: 'file'
        },
        {
          name: 'link',
          type: 'string'
        },
        {
          name: 'text',
          type: 'longText'
        }
      ]
    }
  ]
});
